import { render, staticRenderFns } from "./audioModal.vue?vue&type=template&id=4ff9c1ec&scoped=true&"
import script from "./audioModal.vue?vue&type=script&lang=js&"
export * from "./audioModal.vue?vue&type=script&lang=js&"
import style0 from "./audioModal.vue?vue&type=style&index=0&id=4ff9c1ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9c1ec",
  null
  
)

export default component.exports